<template>
  <div class="batch-export-status">
    <div v-if="props.status === 'failed'">
      <a
        class="status-badge"
        :class="[status]"
        href="#"
        @click.prevent="modalOpen = true"
      >
        <span>{{ statusText }}</span>
        <span class="ml-auto">
          <i class="status-icon" :class="[fontAwesomeIcon]"></i>
        </span>
      </a>
    </div>
    <BatchItemSupportDetails
      :show="showSupportDetails && !!status"
      :batch-id="batchId"
      :batch-item-id="batchItemId"
    />
    <sera-modal
      :open="modalOpen"
      modalTitle="Error Detail"
      hideFooter
      @close="modalOpen = false"
    >
      <div>
        {{ errorText }}
      </div>
    </sera-modal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import BatchItemSupportDetails from "@/Reports/BatchItemSupportDetails.vue";

const props = defineProps({
  showSupportDetails: {
    type: Boolean,
    default: false
  },
  batchId: {
    type: Number,
    default: null
  },
  batchItemId: {
    type: Number,
    default: null
  },
  errorText: {
    type: String,
    default: null
  },
  status: {
    type: String as () => "pending" | "succeeded" | "failed",
    default: null
  },
  statusText: {
    type: String,
    default: null
  }
});

const modalOpen = ref(false);

const fontAwesomeIcon = computed(() => {
  if (props.status === "failed") return "far fa-circle-exclamation";
  return "";
});
</script>

<style lang="scss">
.batch-export-status {
  display: flex;
  align-items: center;
  gap: 5px;
}

.status-badge {
  width: 110px;
  padding: 2px 8px;
  font-weight: 600;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  gap: 5px;

  &.failed {
    color: var(--sera-color-accents-red-600);
    background-color: var(--sera-color-accents-red-200);
  }
}

.status-icon {
  height: 16px;
  width: 16px;
  font-size: 16px;
}
</style>
